import {
  ChevronLeftIcon_default
} from "./chunk-BRKJC7TK.mjs";
export {
  ChevronLeftIcon_default as default
};
